/* istanbul ignore file */

export const WIDGET_COMMUNITY_LIST_TYPE = 'community-list';
